import actionTypes from './types';

const initialState = {
  loadTypes: [],
  consignmentData: {},
  lanes: [],
};

const updateConsignmentReducer = (state: any = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case actionTypes.FETCH_LOAD_TYPES_START: {
      return {
        ...state,
        loadTypes: [],
      };
    }

    case actionTypes.FETCH_LOAD_TYPES_SUCCESS: {
      return {
        ...state,
        loadTypes: action.payload.map((type: string) => ({
          value: type,
          label: type,
        })),
      };
    }

    case actionTypes.FETCH_CONSIGNMENT_DETAILS_START: {
      return {
        ...state,
        consignmentData: {},
      };
    }

    case actionTypes.FETCH_CONSIGNMENT_DETAILS_SUCCESS: {
      return {
        ...state,
        consignmentData: action.payload,
      };
    }

    case actionTypes.FETCH_LANES_START: {
      return {
        ...state,
        lanes: [],
      };
    }

    case actionTypes.FETCH_LANES_SUCCESS: {
      return {
        ...state,
        lanes: action.payload.map((lane: any) => ({
          ...lane,
          value: lane.name,
          label: lane.name,
        })),
      };
    }

    case actionTypes.UPDATE_POLYLINE: {
      return {
        ...state,
        consignmentData: {
          ...state.consignmentData,
          pathPolyLine: action.payload,
        },
      };
    }

    default:
      return state;
  }
};

export default updateConsignmentReducer;
